import React, { useEffect } from "react";

function stripSasTokens(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  doc.querySelectorAll("img").forEach((img) => {
    const src = img.getAttribute("src");
    if (src) {
      try {
        const url = new URL(src);
        url.search = "";
        img.setAttribute("src", url.toString());
      } catch {
        // leave invalid URLs as-is
      }
    }
  });
  return doc.body.innerHTML;
}

const ProcedContent = ({ title, description, media }) => {
  useEffect(() => {
    
  }, []);
  return (
    <div>
      <div className="procedsection">
        <h1 className="procedTitle">{title}</h1>
        <hr />
        <span>
          <div
            className="proced-desc"
            id="proced"
            dangerouslySetInnerHTML={{
              __html: stripSasTokens(description),
            }}
          ></div>
        </span>
        <br />

        {media?.map((media) => (
          <div className="video">
            <br />
            <video src={media} controls />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProcedContent;
